import { Event, NavigationStart, Router, Scroll } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { debounceTime, filter, tap } from 'rxjs';
import { Injectable } from '@angular/core';

import { WindowRef } from '@spartacus/core';

/**
 * The scroll service allows to restore scrolling positions when navigating across pages.
 * In order to work, the following default comportments must be disabled:
 * - Disable the Angular router scrolling core:
 *    withInMemoryScrolling({
 *      scrollPositionRestoration: 'disabled',
 *      anchorScrolling: 'disabled'
 *    })
 * - Disable Spartacus AppRoutingModule scrolling core:
 *    enableResetViewOnNavigate: {
 *      active: false,
 *      ignoreQueryString: true,
 *      ignoreRoutes: []
 *    }
 */
@Injectable({
  providedIn: 'root'
})
export class ScrollService {
  private scrollPos = new Map<string, number>();

  constructor(
    private router: Router,
    private winRef: WindowRef,
    private viewportScroller: ViewportScroller
  ) {}

  watchScroll(): void {
    this.viewportScroller.setHistoryScrollRestoration('manual');

    this.router.events.pipe(
      tap((event) => {
        if (event instanceof NavigationStart) {
          const url = this.router.url;
          if (url) {
            if (url.includes('/p/') || url.includes('/a/') || url.includes('/csp/')) {
              this.winRef.nativeWindow.scrollTo({ top: 0, behavior: 'instant' });
              this.scrollPos.set(url, 0);
            } else {
              this.scrollPos.set(url, this.winRef.nativeWindow.pageYOffset);
            }
          }
        }
      }),
      filter((event: Event): event is Scroll => (
        event instanceof Scroll
      )),
      debounceTime(1000)
    ).subscribe((event) => {
      const { anchor, routerEvent: { url } } = event;
      if (anchor) {
        this.viewportScroller.scrollToAnchor(anchor);
      } else {
        const top = this.scrollPos.get(url) ?? 0;
        if (top !== this.winRef.nativeWindow.pageYOffset) {
          this.winRef.nativeWindow.scrollTo({ top, behavior: 'instant' });
        }
      }
    });
  }
}
